import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const publicAPI = createApi({
    reducerPath: 'publicAPI',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.REACT_APP_HOST_API,
        timeout: 600000
    }),
    endpoints: (builder) => ({
        forgotPasswordRequest: builder.mutation({
            query: (payload) => ({
                url: `/api/v1/profile/reset-password`,
                method: 'POST',
                body: payload,
            })
        })
    })
});

export const {
    useForgotPasswordRequestMutation
} = publicAPI;

export default publicAPI;